import { serverTimestamp } from "firebase/firestore";
import { format } from "date-fns";
import { 
  getAuth
} from "firebase/auth";

function generateID () {
	var ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

	var ID_LENGTH = 12;

	var rtn = '';
	for (var i = 0; i < ID_LENGTH; i++) {
	  rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
	}
	return rtn;
}

function getLang () {
  return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
}

let groupConverter = {
  toFirestore: function(group) {
    return {
      image: group.image,
      name: group.name,
      description: group.description,
      createdDate: group.createdDate,
      updatedDate: group.updatedDate,
      type: group.type,
      orgLink: group.orgLink,
      id: group.id,
      tags: group.tags || [],
      linkedResources: group.linkedResources,
      updater: group.updater,
      archived: group.archived || false
    };
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options);
    return new Group(data)
  }
};

class Group {
  constructor (data) {
    if(!data) data = {}
    this.image = data.image || null;
    this.id = data.id || generateID()
    this.createdDate = data.createdDate || serverTimestamp();
    this.updatedDate = data.updatedDate || serverTimestamp();
    this.description = data.description || "";
    this.type = data.type || "Floor";
    this.orgLink = data.orgLink || "unlinked"
    this.name = data.name || "";
    this.tags = data.tags || [];
    this.linkedResources = data.linkedResources || []
    this.loadedData = true;
    this.hotspot = data.hotspot || null;
    this.updater = data.updater || null
    this.archived = data.archived || false;
  }
}

let resourceConverter = {
  toFirestore: function(resource) {
    return {
      archived: resource.archived,
      image: resource.image,
      name: resource.name,
      description: resource.description,
      createdDate: resource.createdDate,
      updatedDate: resource.updatedDate,
      type: resource.type,
      orgLink: resource.orgLink,
      id: resource.id || null,
      reservations: resource.reservations,
      tags: resource.tags || [],
      updater: resource.updater || null
    };
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options);
    return new Resource(data)
  }
};

class Resource {
  constructor (data) {
    if(!data) data = {}
    this.image = data.image || null;
    this.id = data.id || generateID()
    this.createdDate = data.createdDate || serverTimestamp();
    this.updatedDate = data.updatedDate || serverTimestamp();
    this.description = data.description || "";
    this.type = data.type || "Desk";
    this.orgLink = data.orgLink || "unlinked"
    this.name = data.name || "";
    // this.booked = false,
    // this.bookedByUser = false,
    this.reservations = data.reservations || {
      onceOff: []
    },
    this.tags = data.tags || [],
    this.loadedData = true; // used for knowing when the resource was fetched
    this.notFound = data.notFound || false // used for when a resouce cannout be found
    this.state = null  // used for handling UI state like loading etc.
    this.archived = data.archived || false,
    this.updater = data.updater || null,
    this.isFav = false // used so that heart can be red immediately when user favourites a resource
  }
}

let userDataConverter = {
  toFirestore: function(data) {
    return data;
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options);
    return new userData(snapshot.id, data)
  }
}

class userData {
  constructor (id, data) {
    this.id = id
    this.adminConfig = data.adminConfig || {viewJSON: false}
    this.config = data.config || {locale: 'en-GB'}
    this.email = data.email || null,
    this.orgs = data.orgs || {}
  }
}

let orgConverter = {
  toFirestore: function(data) {    
    return data;
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options);
    return new Org(data)
  }
}

class Org {
  constructor (data) {
    if(!data) data = {};
    // slight hack to make cypress testing a little easier
    if(data.name === 'cypresstest-org') {
      data.id = "cypresstest-org"
    }
    this.id = data.id || data.name + "_"+generateID();
    this.archived = data.archived || false;
    this.owner = data.owner || {
      email: null,
      id: null
    };
    this.onboarding = data.onboarding || {
      invitedGuests: false,
      createdResources: false,
      customised: false,
      sharedLink: false,
      dismissed: false
    };
    this.teammates = data.teammates || [];
    this.guests = data.guests || [];
    this.name = data.name || "";
    this.createdDate = data.createdDate || serverTimestamp();
    this.updatedDate = data.updatedDate || serverTimestamp();
    this.plan = data.plan || 0;
    this.logo = data.logo || {
      basic: null,
      wordmark: null,
      withBackground: null,
      transparent: null
    };
    this.customisations = data.customisations || {
      localeOverrides: {
        "group-edit-type-custom-1": null,
        "group-edit-type-custom-2": null,
        "resource-edit-type-custom-1": null,
        "resource-edit-type-custom-2": null,
        "reserve-resource-cta": null,
      },
      type: {
        font: null,
        headingsCase: null,
      },
      colourPrimary: null,
      colourSecondary: null,
      colourTertiary: null,
      buttons: {
        rounding: "light",
        shadow: true,
      },
    };
  }
}

function wait (ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

function formatDate(time, dateFormat) {
  time = time || new Date().getTime()
  time = parseInt(time)  
  return format(new Date(time), dateFormat || "h:mm a - do MMM yyyy z");
}

async function getUserClaims() {
  const auth = getAuth();
  const token = await auth.currentUser.getIdTokenResult();
  return token.claims
}

export default {
  generateID,
  getLang,
  resourceConverter,
  Resource,
  userDataConverter,
  Org,
  orgConverter,
  Group,
  groupConverter,
  wait,
  formatDate,
  getUserClaims
};
